import React from 'react';
import CounselorAccount from 'pages/counselor/account/Account';

const Profile = () => {
    return <CounselorAccount />;
};

export default Profile;
